import axios from 'axios';
import { models } from 'powerbi-client';
import { PowerBIEmbed } from 'powerbi-client-react';
import React, { useRef, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';
import './powerbiEmbed.css';

// eslint-disable-next-line react/prop-types
export default function PowerBIReport({ reportId, pageName }) {
  const boxRef = useRef(null);
  const [reportData, setReportData] = useState({
    EmbedToken: '',
    EmbedUrl: '',
    ReportId: '',
  });
  const [loading, setLoading] = useState(true);
  const reportRef = useRef(null); // Reference to the embedded report

  const azureFunction = 'https://powerbiembed1.azurewebsites.net/api/PowerBIEmbeddedToken';
  const azureFunctionCode = 'TTQqiM8UlHYbnunE3NUcZ0IbeUUwRtYqxo/ANv5WjzechN6m2GuzRw==';
  const serviceURL = `${azureFunction}?code=${azureFunctionCode}`;

  const jsonData = {
    reportId,
  };

  const config = {
    data: JSON.stringify(jsonData),
  };

  useEffect(() => {
    axios
      .post(serviceURL, config.data)
      .then((res) =>
        setReportData({
          EmbedToken: res.data.EmbedToken,
          EmbedUrl: res.data.EmbedUrl,
          ReportId: res.data.ReportId,
        })
      )
      .catch((error) => setReportData(false))
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportId]);

  // This function will be called to navigate to a specific page
 const navigateToPage = (report) => {
    if (pageName) {
      report.getPages().then((pages) => {
        console.log('Available pages:', pages); // Log all pages
        const targetPage = pages.find((page) => page.displayName === pageName);
        if (targetPage) {
          targetPage.setActive();
        } else {
          console.error(`Page with name "${pageName}" not found`);
        }
      });
    }
  };

  // Set height based on the pageName
  const getHeightForPage = (pageNameHeight) => {
    if (pageNameHeight === 'Denials Main Dashboard' || pageNameHeight === 'Charges Main Dashboard') {
      return '2200px';
    }
    if (pageNameHeight === 'A/R') {
      return '3000px';
    }
    // Default to using aspect ratio for other pages
    return 'auto';
  };

  return (
    <Box
      ref={boxRef}
      sx={{
        borderRadius: 2,
        bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
        border: (theme) => `dashed 1px ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        mt: -2,
        padding: -2,
        flexDirection: 'column',
      }}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        <div
          style={{
            width: '100%',
            maxWidth: '100%',
            height: getHeightForPage(pageName) !== 'auto' ? getHeightForPage(pageName) : '3000px',
            aspectRatio: getHeightForPage(pageName) === 'auto' ? '2560 / 1600' : 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <PowerBIEmbed
            embedConfig={{
              type: 'report',
              id: reportId,
              embedUrl: reportData.EmbedUrl,
              accessToken: reportData.EmbedToken,
              tokenType: models.TokenType.Embed,
              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                },
                navContentPaneEnabled: false,
                background: models.BackgroundType.Transparent,
                layoutType: models.LayoutType.FitToWidth,
              },
            }}
            eventHandlers={
              new Map([
                [
                  'loaded',
                  function () {
                    console.log('Report loaded');
                    // Navigate to the page after the report is loaded
                    if (reportRef.current) {
                      navigateToPage(reportRef.current);
                    }
                  },
                ],
                [
                  'rendered',
                  function () {
                    console.log('Report rendered');
                  },
                ],
                [
                  'error',
                  function (event) {
                    console.log(event.detail);
                  },
                ],
                ['visualClicked', () => console.log('visual clicked')],
                ['pageChanged', (event) => console.log(event)],
              ])
            }
            cssClassName="report-style-class"
            getEmbeddedComponent={(embeddedReport) => {
              reportRef.current = embeddedReport; // Store the embedded report instance
            }}
            style={{
              width: '100%',
              height: '100%',
              maxWidth: '100%',
            }}
          />
        </div>
      )}
    </Box>
  );
}

